import { readConfiguredHaniverseWorkerUrl } from "#read-configured-haniverse-worker-url";

/** Base URL of the `haniverse-worker` (web and server: the configured URL as it is). */
export function resolveHanWorkerUrl(): string {
  return readConfiguredHaniverseWorkerUrl();
}
